import React from "react";
import Header from "../../components/Header";
import "./style.css";

const About = () => (
  <div className="about-page">
    <Header activePath="" />

    <div className="about-hero">
      <div className="about-hero-bg">
        <div className="about-hero-shape shape-1" />
        <div className="about-hero-shape shape-2" />
        <div className="about-hero-shape shape-3" />
      </div>
      <div className="about-hero-content">
        <div className="about-hero-badge">
          <span>关于我们</span>
        </div>
        <h1 className="about-hero-title">让智能赋能生活</h1>
        <p className="about-hero-desc">
          积致科技（北京）有限公司 · 创立于2014年
        </p>
      </div>
    </div>

    <div className="about-sections">
      <section className="about-section">
        <div className="about-container">
          <div className="about-section-label">产品服务</div>
          <h2 className="about-section-title">秒应 - 安全好用的接龙投票预约管家</h2>
          <div className="about-section-content">
            <div className="about-content-block">
              <p className="about-para">
                秒应是积致科技精心打造的群组协作管理工具，专注于解决微信群接龙、投票统计、活动预约等日常场景中的管理难题。无论是老师布置任务、班委组织活动，还是行政人员统计信息，秒应都能让群组协作变得简单高效。
              </p>
              <p className="about-para">
                作为群接龙打卡报名神器，秒应支持微信群接龙、投票统计、活动预约等多种功能，帮助群组高效协作，管理更轻松。数据自动汇总导出，省时省力不刷屏，让老师、班委、行政都能从繁琐的统计工作中解放出来。
              </p>
              <p className="about-para">
                我们的使命是让每一次接龙都变得简单，通过智能化工具为科技浇筑温情、让智能赋能生活。
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="about-section about-section-alt">
        <div className="about-container">
          <div className="about-section-label">关于我们</div>
          <h2 className="about-section-title">积致科技（北京）有限公司</h2>
          <div className="about-section-content">
            <div className="about-content-block">
              <p className="about-para">
                积致科技（北京）有限公司创立于2014年8月20日，是互联网思维与人文关怀共生的一家新时代科技公司。
              </p>
              <p className="about-para">
                积致希望以人工智能去赋能产品，坚持在功能开发上兼顾创新与人性化，同时重视用户在使用过程中的服务体验，做到为科技浇筑温情、让智能赋能生活。
              </p>
            </div>
            <div className="about-values">
              <div className="value-card">
                <div className="value-icon">💡</div>
                <h3>创新与人性化</h3>
                <p>坚持在功能开发上兼顾创新与人性化，让产品既先进又易用</p>
              </div>
              <div className="value-card">
                <div className="value-icon">❤️</div>
                <h3>服务体验</h3>
                <p>重视用户在使用过程中的服务体验，做有温度的科技产品</p>
              </div>
              <div className="value-card">
                <div className="value-icon">🎯</div>
                <h3>让智能赋能生活</h3>
                <p>为科技浇筑温情，用人工智能赋能日常，让生活更简单</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
);

export default About;
